import { logError } from './logUtils';

export type ErrorBoundaryInfo = {
  componentStack?: string | null;
  digest?: string | null;
}

export const handleErrorBoundary = (error: Error, _info: ErrorBoundaryInfo) => {
  logError(error, 'error');
};
